import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LclAggregatedStatisticsModel } from '@data-layer/models/lcl/lcl-aggregated-statistics.model';

@Component({
  selector: 'app-lcl-shipment-totals-info',
  templateUrl: './lcl-shipment-totals-info.component.html',
  styleUrls: ['./lcl-shipment-totals-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclShipmentTotalsInfoComponent implements OnInit {
  @Input() public aggregatedStatistics: LclAggregatedStatisticsModel;
  constructor() {}

  public ngOnInit(): void {}
}
